// import React, { useEffect, useMemo, useState } from "react";
// import api from "../../api";
// import Can from "../../components/Can";
// import {
//   Table,
//   Button,
//   Form,
//   Pagination,
//   InputGroup,
//   Modal,
//   Spinner,
//   Alert,
//   Badge,
// } from "react-bootstrap";
// import "./AdminUnitPage.css";
// import "./AdminCompanyPage.css";
// import { getSerialNumber } from "../../utils/pagination";
// import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

// export default function AdminCompanyPage() {
//   const [companies, setCompanies] = useState([]);

//   const [formData, setFormData] = useState({
//     company_name: "",
//     address: "",
//     phone_number: "",
//     email: "",
//   });

//   const [editId, setEditId] = useState(null);
//   const [search, setSearch] = useState("");
//   const [sortField, setSortField] = useState("id");
//   const [sortOrder, setSortOrder] = useState("asc");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [companiesPerPage, setCompaniesPerPage] = useState(10);

//   const [showModal, setShowModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [message, setMessage] = useState("");
//   const [messageType, setMessageType] = useState("success");

//   useEffect(() => {
//     fetchCompanies();
//   }, []);

//   const showMessage = (type, text) => {
//     setMessageType(type);
//     setMessage(text);
//     setTimeout(() => setMessage(""), 3000);
//   };

//   const fetchCompanies = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get(`/companies`);
//       setCompanies(Array.isArray(res.data?.data) ? res.data.data : res.data || []);
//     } catch (error) {
//       console.error("Fetch Companies Error:", error);
//       showMessage("danger", "Failed to fetch companies");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filteredCompanies = useMemo(() => {
//     let data = [...companies];

//     if (search.trim()) {
//       const keyword = search.toLowerCase();

//       data = data.filter(
//         (company) =>
//           company.company_name?.toLowerCase().includes(keyword) ||
//           company.email?.toLowerCase().includes(keyword) ||
//           company.phone_number?.toLowerCase().includes(keyword) ||
//           company.address?.toLowerCase().includes(keyword)
//       );
//     }

//     data.sort((a, b) => {
//       let valueA = a[sortField];
//       let valueB = b[sortField];

//       if (typeof valueA === "string") valueA = valueA.toLowerCase();
//       if (typeof valueB === "string") valueB = valueB.toLowerCase();

//       if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
//       if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
//       return 0;
//     });

//     return data;
//   }, [companies, search, sortField, sortOrder]);

//   const totalPages = Math.ceil(filteredCompanies.length / companiesPerPage);
//   const indexOfLast = currentPage * companiesPerPage;
//   const indexOfFirst = indexOfLast - companiesPerPage;
//   const currentCompanies = filteredCompanies.slice(indexOfFirst, indexOfLast);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [search, companiesPerPage]);

//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
//     } else {
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   const getSortIcon = (field) => {
//     if (sortField !== field) return "↕";
//     return sortOrder === "asc" ? "↑" : "↓";
//   };

//   const handleChange = (e) => {
//     setFormData((prev) => ({
//       ...prev,
//       [e.target.name]: e.target.value,
//     }));
//   };

//   const resetForm = () => {
//     setFormData({
//       company_name: "",
//       address: "",
//       phone_number: "",
//       email: "",
//     });
//     setEditId(null);
//   };

//   const handleAdd = () => {
//     resetForm();
//     setShowModal(true);
//   };

//   const handleEdit = (company) => {
//     setFormData({
//       company_name: company.company_name || "",
//       address: company.address || "",
//       phone_number: company.phone_number || "",
//       email: company.email || "",
//     });
//     setEditId(company.id);
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     resetForm();
//   };

//   const handleSubmit = async () => {
//     if (!formData.company_name.trim()) {
//       showMessage("danger", "Please enter company name");
//       return;
//     }

//     try {
//       setSaving(true);

//       const payload = {
//         company_name: formData.company_name.trim(),
//         address: formData.address.trim(),
//         phone_number: formData.phone_number.trim(),
//         email: formData.email.trim(),
//       };

//       if (editId) {
//         await api.put(`/companies/${editId}`, payload);
//         showMessage("success", "Company updated successfully");
//       } else {
//         await api.post(`/companies`, payload);
//         showMessage("success", "Company added successfully");
//       }

//       handleCloseModal();
//       fetchCompanies();
//     } catch (error) {
//       console.error("Save Company Error:", error);
//       showMessage(
//         "danger",
//         editId ? "Failed to update company" : "Failed to add company"
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   const openDeleteModal = (id) => {
//     setDeleteId(id);
//     setShowDeleteModal(true);
//   };

//   const closeDeleteModal = () => {
//     setDeleteId(null);
//     setShowDeleteModal(false);
//   };

//   const confirmDelete = async () => {
//     try {
//       await api.delete(`/companies/${deleteId}`);
//       showMessage("success", "Company deleted successfully");
//       closeDeleteModal();
//       fetchCompanies();
//     } catch (error) {
//       console.error("Delete Company Error:", error);
//       showMessage("danger", "Failed to delete company");
//     }
//   };

//   const exportCSV = () => {
//     if (!filteredCompanies.length) {
//       showMessage("danger", "No data available to export");
//       return;
//     }

//     const headers = ["ID", "Company Name", "Address", "Phone Number", "Email"];
//     const rows = filteredCompanies.map((company) => [
//       company.id,
//       company.company_name,
//       company.address,
//       company.phone_number,
//       company.email,
//     ]);

//     const csvContent = [headers, ...rows]
//       .map((row) =>
//         row
//           .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
//           .join(",")
//       )
//       .join("\n");

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "companies.csv";
//     link.click();

//     URL.revokeObjectURL(url);
//   };

//   return (
//     <div className="unit-page company-mgmt-theme">
//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Configuration</div>
//           <h2>Company Management</h2>
//           <p>Manage company details, address, phone number and email.</p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchCompanies}>
//             Refresh
//           </Button>

//           <Button className="unit-btn unit-btn-light" onClick={exportCSV}>
//             Export CSV
//           </Button>

//           <Can moduleKey="companies" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={handleAdd}>
//               + Add Company
//             </Button>
//           </Can>
//         </div>
//       </div>

//       {message && (
//         <Alert variant={messageType} className="unit-alert">
//           {message}
//         </Alert>
//       )}

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <div className="company-stat-icon company-stat-icon-primary">
//             <i className="fa-solid fa-building" aria-hidden="true"></i>
//           </div>
//           <div className="company-stat-text">
//             <span>Total Companies</span>
//             <strong>{companies.length}</strong>
//           </div>
//         </div>

//         <div className="unit-stat-card">
//           <div className="company-stat-icon company-stat-icon-accent">
//             <i className="fa-solid fa-filter" aria-hidden="true"></i>
//           </div>
//           <div className="company-stat-text">
//             <span>Filtered Result</span>
//             <strong>{filteredCompanies.length}</strong>
//           </div>
//         </div>

//         <div className="unit-stat-card">
//           <div className="company-stat-icon company-stat-icon-success">
//             <i className="fa-solid fa-list-ol" aria-hidden="true"></i>
//           </div>
//           <div className="company-stat-text">
//             <span>Current Page</span>
//             <strong>{currentPage}</strong>
//           </div>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-building-columns company-list-icon" aria-hidden="true"></i>
//               Company List
//             </h5>
//             <p>View, search, sort, add, update and delete companies.</p>
//           </div>

//           <div className="unit-toolbar-actions">
//             <InputGroup className="unit-search">
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search company, email, phone..."
//                 aria-label="Search company, email, phone"
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />
//               {search && (
//                 <Button className="unit-clear-btn" onClick={() => setSearch("")}>
//                   Clear
//                 </Button>
//               )}
//             </InputGroup>

//             <Form.Select
//               className="unit-page-size"
//               value={companiesPerPage}
//               onChange={(e) => setCompaniesPerPage(Number(e.target.value))}
//             >
//               <option value={5}>5 rows</option>
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading companies...</p>
//             </div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th style={{ width: 70 }}>S.NO.</th>
//                   <th onClick={() => handleSort("company_name")} className="sortable">
//                     Company {getSortIcon("company_name")}
//                   </th>
//                   <th>Phone</th>
//                   <th>Email</th>
//                   <th>Address</th>
//                   <th>Status</th>
//                   <th className="text-end">Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {currentCompanies.length > 0 ? (
//                   currentCompanies.map((company, index) => (
//                     <tr key={company.id}>
//                       <td>{getSerialNumber(index, currentPage, companiesPerPage)}</td>

//                       <td>
//                         <div className="unit-name-box">
//                           <div className="unit-letter">
//                             {company.company_name?.charAt(0)?.toUpperCase()}
//                           </div>
//                           <div>
//                             <strong>{company.company_name}</strong>
//                             <small>Company ID: {company.id}</small>
//                           </div>
//                         </div>
//                       </td>

//                       <td>{company.phone_number || "-"}</td>
//                       <td>{company.email || "-"}</td>
//                       <td>{company.address || "-"}</td>

//                       <td>
//                         <Badge className="unit-status">Active</Badge>
//                       </td>

//                       <td>
//                         <div className="unit-actions">
//                           <Can moduleKey="companies" actionKey="edit">
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               onClick={() => handleEdit(company)}
//                               title="Edit"
//                               aria-label={`Edit ${company.company_name || "company"}`}
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>
//                           </Can>

//                           <Can moduleKey="companies" actionKey="delete">
//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               onClick={() => openDeleteModal(company.id)}
//                               title="Delete"
//                               aria-label={`Delete ${company.company_name || "company"}`}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>
//                           </Can>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="7">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-building" aria-hidden="true"></i>
//                         </div>
//                         <h5>No companies found</h5>
//                         <p>Try another keyword or add a new company.</p>
//                         <Button className="unit-btn unit-btn-primary" onClick={handleAdd}>
//                           + Add Company
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing{" "}
//             <strong>{filteredCompanies.length === 0 ? 0 : indexOfFirst + 1}</strong>{" "}
//             to <strong>{Math.min(indexOfLast, filteredCompanies.length)}</strong>{" "}
//             of <strong>{filteredCompanies.length}</strong> entries
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage((prev) => prev - 1)}
//               />

//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item
//                   key={i + 1}
//                   active={i + 1 === currentPage}
//                   onClick={() => setCurrentPage(i + 1)}
//                 >
//                   {i + 1}
//                 </Pagination.Item>
//               ))}

//               <Pagination.Next
//                 disabled={currentPage === totalPages}
//                 onClick={() => setCurrentPage((prev) => prev + 1)}
//               />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal
//         show={showModal}
//         onHide={handleCloseModal}
//         centered
//         className="unit-modal"
//         dialogClassName="admin-teal-modal"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton closeLabel="Close">
//           <div className="d-flex align-items-center">
//             <BusinessOutlinedIcon className="modal-header-icon" aria-hidden="true" />
//             <Modal.Title>{editId ? "Edit Company" : "Add New Company"}</Modal.Title>
//           </div>
//         </Modal.Header>

//         <Modal.Body>
//           <Form.Group className="mb-3">
//             <Form.Label>Company Name</Form.Label>
//             <Form.Control
//               type="text"
//               name="company_name"
//               placeholder="Example: ABC Technologies"
//               value={formData.company_name}
//               onChange={handleChange}
//               autoFocus
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Phone Number</Form.Label>
//             <Form.Control
//               type="text"
//               name="phone_number"
//               placeholder="Example: 9876543210"
//               value={formData.phone_number}
//               onChange={handleChange}
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Email</Form.Label>
//             <Form.Control
//               type="email"
//               name="email"
//               placeholder="Example: info@company.com"
//               value={formData.email}
//               onChange={handleChange}
//             />
//           </Form.Group>

//           <Form.Group>
//             <Form.Label>Address</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={3}
//               name="address"
//               placeholder="Enter company address"
//               value={formData.address}
//               onChange={handleChange}
//             />
//           </Form.Group>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={handleCloseModal}>
//             Cancel
//           </Button>

//           <Button
//             className="unit-btn unit-btn-primary"
//             onClick={handleSubmit}
//             disabled={saving}
//           >
//             {saving ? "Saving..." : editId ? "Update Company" : "Create Company"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal
//         show={showDeleteModal}
//         onHide={closeDeleteModal}
//         centered
//         className="unit-modal"
//         dialogClassName="admin-teal-modal admin-teal-modal-sm admin-teal-modal-danger"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton closeLabel="Close">
//           <Modal.Title>Delete Company?</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <div className="admin-modal-danger-icon" aria-hidden="true">
//             <DeleteOutlineIcon fontSize="inherit" />
//           </div>
//           <p className="unit-delete-text text-center">
//             Are you sure you want to delete this company? This action cannot be undone.
//           </p>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
//             Cancel
//           </Button>

//           <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }





import React, { useEffect, useMemo, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import api from "../../api";
import Can from "../../components/Can";
import {
  Table,
  Button,
  Form,
  Pagination,
  InputGroup,
  Modal,
  Spinner,
  Alert,
  Badge,
} from "react-bootstrap";
import "./AdminCompanyPage.css";
import { getSerialNumber } from "../../utils/pagination";

export default function AdminCompanyPage() {
  const [companies, setCompanies] = useState([]);

  const [formData, setFormData] = useState({
    company_name: "",
    address: "",
    phone_number: "",
    email: "",
  });

  const [editId, setEditId] = useState(null);
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState("id");
  const [sortOrder, setSortOrder] = useState("asc");

  const [currentPage, setCurrentPage] = useState(1);
  const [companiesPerPage, setCompaniesPerPage] = useState(10);

  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");

  useEffect(() => {
    fetchCompanies();
  }, []);

  const showMessage = (type, text) => {
    setMessageType(type);
    setMessage(text);
    setTimeout(() => setMessage(""), 3000);
  };

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/companies`);
      setCompanies(Array.isArray(res.data?.data) ? res.data.data : res.data || []);
    } catch (error) {
      console.error("Fetch Companies Error:", error);
      showMessage("danger", "Failed to fetch companies");
    } finally {
      setLoading(false);
    }
  };

  const filteredCompanies = useMemo(() => {
    let data = [...companies];

    if (search.trim()) {
      const keyword = search.toLowerCase();

      data = data.filter(
        (company) =>
          company.company_name?.toLowerCase().includes(keyword) ||
          company.email?.toLowerCase().includes(keyword) ||
          company.phone_number?.toLowerCase().includes(keyword) ||
          company.address?.toLowerCase().includes(keyword)
      );
    }

    data.sort((a, b) => {
      let valueA = a[sortField];
      let valueB = b[sortField];

      if (typeof valueA === "string") valueA = valueA.toLowerCase();
      if (typeof valueB === "string") valueB = valueB.toLowerCase();

      if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
      if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });

    return data;
  }, [companies, search, sortField, sortOrder]);

  const totalPages = Math.ceil(filteredCompanies.length / companiesPerPage);
  const indexOfLast = currentPage * companiesPerPage;
  const indexOfFirst = indexOfLast - companiesPerPage;
  const currentCompanies = filteredCompanies.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [search, companiesPerPage]);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const getSortIcon = (field) => {
    if (sortField !== field) return "↕";
    return sortOrder === "asc" ? "↑" : "↓";
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const resetForm = () => {
    setFormData({
      company_name: "",
      address: "",
      phone_number: "",
      email: "",
    });
    setEditId(null);
  };

  const handleAdd = () => {
    resetForm();
    setShowModal(true);
  };

  const handleEdit = (company) => {
    setFormData({
      company_name: company.company_name || "",
      address: company.address || "",
      phone_number: company.phone_number || "",
      email: company.email || "",
    });
    setEditId(company.id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    resetForm();
  };

  const handleSubmit = async () => {
    if (!formData.company_name.trim()) {
      showMessage("danger", "Please enter company name");
      return;
    }

    try {
      setSaving(true);

      const payload = {
        company_name: formData.company_name.trim(),
        address: formData.address.trim(),
        phone_number: formData.phone_number.trim(),
        email: formData.email.trim(),
      };

      if (editId) {
        await api.put(`/companies/${editId}`, payload);
        showMessage("success", "Company updated successfully");
      } else {
        await api.post(`/companies`, payload);
        showMessage("success", "Company added successfully");
      }

      handleCloseModal();
      fetchCompanies();
    } catch (error) {
      console.error("Save Company Error:", error);
      showMessage(
        "danger",
        editId ? "Failed to update company" : "Failed to add company"
      );
    } finally {
      setSaving(false);
    }
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteId(null);
    setShowDeleteModal(false);
  };

  const confirmDelete = async () => {
    try {
      await api.delete(`/companies/${deleteId}`);
      showMessage("success", "Company deleted successfully");
      closeDeleteModal();
      fetchCompanies();
    } catch (error) {
      console.error("Delete Company Error:", error);
      showMessage("danger", "Failed to delete company");
    }
  };

  const exportCSV = () => {
    if (!filteredCompanies.length) {
      showMessage("danger", "No data available to export");
      return;
    }

    const headers = ["ID", "Company Name", "Address", "Phone Number", "Email"];
    const rows = filteredCompanies.map((company) => [
      company.id,
      company.company_name,
      company.address,
      company.phone_number,
      company.email,
    ]);

    const csvContent = [headers, ...rows]
      .map((row) =>
        row
          .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
          .join(",")
      )
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "companies.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  return (
    <div className="unit-page company-mgmt-theme">
      <div className="company-heading-box">
        <div className="company-heading-content">
          <div className="company-heading-icon">
            <i className="fa-solid fa-building-columns" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Configuration</div>
            <h2>Company Management</h2>
            <p>Manage company details, address, phone number and email.</p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchCompanies}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>

          <Button className="unit-btn unit-btn-light" onClick={exportCSV}>
            <i className="fa-solid fa-file-export" aria-hidden="true"></i>
            Export CSV
          </Button>

          <Can moduleKey="companies" actionKey="create">
            <Button className="unit-btn unit-btn-primary" onClick={handleAdd}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Add Company
            </Button>
          </Can>
        </div>
      </div>

      {message && (
        <Alert variant={messageType} className="unit-alert">
          <i
            className={
              messageType === "success"
                ? "fa-solid fa-circle-check"
                : "fa-solid fa-circle-exclamation"
            }
            aria-hidden="true"
          ></i>
          <span>{message}</span>
        </Alert>
      )}

      <div className="unit-stats-row">
        <div className="unit-stat-card company-stat-blue">
          <div className="company-stat-content">
            <div className="company-stat-text">
              <span>Total Companies</span>
              <strong>{companies.length}</strong>
            </div>

            <div className="company-stat-icon">
              <i className="fa-solid fa-building" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card company-stat-purple">
          <div className="company-stat-content">
            <div className="company-stat-text">
              <span>Filtered Result</span>
              <strong>{filteredCompanies.length}</strong>
            </div>

            <div className="company-stat-icon">
              <i className="fa-solid fa-filter" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card company-stat-green">
          <div className="company-stat-content">
            <div className="company-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>

            <div className="company-stat-icon">
              <i className="fa-solid fa-list-ol" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar">
          <div className="company-section-title">
            <div className="company-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div>
              <h5>Company List</h5>
              <p>View, search, sort, add, update and delete companies.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions">
            <InputGroup className="unit-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder="Search company, email, phone..."
                aria-label="Search company, email, phone"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => setSearch("")}
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>

            <Form.Select
              className="unit-page-size"
              value={companiesPerPage}
              onChange={(e) => setCompaniesPerPage(Number(e.target.value))}
            >
              <option value={5}>5 rows</option>
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading companies...</p>
            </div>
          ) : (
            <Table responsive className="unit-table">
              <thead>
                <tr>
                  <th style={{ width: 70 }}>S.NO.</th>
                  <th onClick={() => handleSort("company_name")} className="sortable">
                    Company {getSortIcon("company_name")}
                  </th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Address</th>
                  <th>Status</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                {currentCompanies.length > 0 ? (
                  currentCompanies.map((company, index) => (
                    <tr key={company.id}>
                      <td>{getSerialNumber(index, currentPage, companiesPerPage)}</td>

                      <td>
                        <div className="unit-name-box">
                          <div className="unit-letter">
                            {company.company_name?.charAt(0)?.toUpperCase()}
                          </div>
                          <div>
                            <strong>{company.company_name}</strong>
                            <small>Company ID: {company.id}</small>
                          </div>
                        </div>
                      </td>

                      <td>
                        <span className="company-contact company-contact-phone">
                          <i className="fa-solid fa-phone" aria-hidden="true"></i>
                          {company.phone_number || "-"}
                        </span>
                      </td>
                      <td>
                        <span className="company-contact company-contact-email">
                          <i className="fa-regular fa-envelope" aria-hidden="true"></i>
                          {company.email || "-"}
                        </span>
                      </td>
                      <td>
                        <div
                          className="company-address"
                          title={company.address || "-"}
                        >
                          <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
                          <span>{company.address || "-"}</span>
                        </div>
                      </td>

                      <td>
                        <Badge className="unit-status company-status-active">
                          <i className="fa-solid fa-circle-check me-1" aria-hidden="true"></i>
                          Active
                        </Badge>
                      </td>

                      <td>
                        <div className="unit-actions">
                          <Can moduleKey="companies" actionKey="edit">
                            <Button
                              className="unit-icon-btn unit-edit"
                              onClick={() => handleEdit(company)}
                              title="Edit"
                              aria-label={`Edit ${company.company_name || "company"}`}
                            >
                              <i className="fa-solid fa-pen" aria-hidden="true"></i>
                            </Button>
                          </Can>

                          <Can moduleKey="companies" actionKey="delete">
                            <Button
                              className="unit-icon-btn unit-delete"
                              onClick={() => openDeleteModal(company.id)}
                              title="Delete"
                              aria-label={`Delete ${company.company_name || "company"}`}
                            >
                              <i className="fa-solid fa-trash" aria-hidden="true"></i>
                            </Button>
                          </Can>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-building" aria-hidden="true"></i>
                        </div>
                        <h5>No companies found</h5>
                        <p>Try another keyword or add a new company.</p>
                        <Button className="unit-btn unit-btn-primary" onClick={handleAdd}>
                          <i className="fa-solid fa-plus" aria-hidden="true"></i>
                          Add Company
                        </Button>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing{" "}
            <strong>{filteredCompanies.length === 0 ? 0 : indexOfFirst + 1}</strong>{" "}
            to <strong>{Math.min(indexOfLast, filteredCompanies.length)}</strong>{" "}
            of <strong>{filteredCompanies.length}</strong> entries
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
              />

              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item
                  key={i + 1}
                  active={i + 1 === currentPage}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Pagination.Item>
              )), currentPage)}

              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => prev + 1)}
              />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        className="unit-modal"
        dialogClassName="company-admin-modal"
        backdropClassName="company-admin-backdrop"
      >
        <Modal.Header closeButton closeLabel="Close">
          <div className="company-modal-heading">
            <div className="company-modal-icon">
              <i
                className={
                  editId
                    ? "fa-solid fa-pen-to-square"
                    : "fa-solid fa-building-circle-arrow-right"
                }
                aria-hidden="true"
              ></i>
            </div>

            <div>
              <small>Company Setup</small>
              <Modal.Title>{editId ? "Edit Company" : "Add New Company"}</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Company Name</Form.Label>
            <div className="company-modal-field">
              <i className="fa-solid fa-building" aria-hidden="true"></i>
              <Form.Control
                type="text"
                name="company_name"
                placeholder="Example: ABC Technologies"
                value={formData.company_name}
                onChange={handleChange}
                autoFocus
              />
            </div>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Phone Number</Form.Label>
            <div className="company-modal-field">
              <i className="fa-solid fa-phone" aria-hidden="true"></i>
              <Form.Control
                type="text"
                name="phone_number"
                placeholder="Example: 9876543210"
                value={formData.phone_number}
                onChange={handleChange}
              />
            </div>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <div className="company-modal-field">
              <i className="fa-regular fa-envelope" aria-hidden="true"></i>
              <Form.Control
                type="email"
                name="email"
                placeholder="Example: info@company.com"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          </Form.Group>

          <Form.Group>
            <Form.Label>Address</Form.Label>
            <div className="company-modal-field company-modal-field-textarea">
              <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
              <Form.Control
                as="textarea"
                rows={3}
                name="address"
                placeholder="Enter company address"
                value={formData.address}
                onChange={handleChange}
              />
            </div>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={handleCloseModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-primary"
            onClick={handleSubmit}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                {editId ? "Update Company" : "Create Company"}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={closeDeleteModal}
        centered
        className="unit-modal"
        dialogClassName="company-admin-modal company-admin-modal-sm company-admin-modal-danger"
        backdropClassName="company-admin-backdrop"
      >
        <Modal.Header closeButton closeLabel="Close">
          <div className="company-modal-heading">
            <div className="company-modal-icon company-modal-icon-danger">
              <i className="fa-solid fa-trash" aria-hidden="true"></i>
            </div>

            <div>
              <small>Delete Action</small>
              <Modal.Title>Delete Company?</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="company-modal-danger-visual" aria-hidden="true">
            <i className="fa-solid fa-building-circle-xmark"></i>
          </div>
          <p className="unit-delete-text text-center">
            Are you sure you want to delete this company? This action cannot be undone.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
            <i className="fa-solid fa-trash" aria-hidden="true"></i>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}